import Performance from './mainSection/svg/new/Performance';
import Recruitment from './mainSection/svg/new/Recruitment';
import { HrmDualToneTitle } from './HrmDualToneTitle';
import Interface from './mainSection/svg/new/Interface';

export function HrmManagement({ title, description, icon }: { title: string; description: string; icon?: string }) {
    const illustrations = {
        recruitment: <Recruitment />,
        interface: <Interface />,
        performance: <Performance />,
    };
    return (
        <section className="my-[20px] shadow-sm rounded-lg p-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-14 items-center">
                <div className="lg:col-span-2 col-span-1 flex flex-col justify-center lg:order-1 order-2">
                    <HrmDualToneTitle title={title} />
                    <p className="mt-6 text-primary-text/90 font-medium sm:text-base text-[15px] lg:text-[20px] leading-relaxed pl-6 ml-auto">
                        {description}
                    </p>
                </div>

                <div className="flex justify-center lg:justify-start lg:order-2 order-1 motion-safe:animate-float">
                    {illustrations[icon as keyof typeof illustrations]}
                </div>
            </div>
        </section>
    );
}
